import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" eyebrow="Prima di decidere" title="Domande frequenti" data-id="element-44" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-narrow space-y-3" data-id="element-45" data-mp="1gal2xrndzzfc">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-gray-200" data-id="element-46" data-mp="292eg1a85g4sb" data-mpi={index}>
              <h3 data-id="element-47" data-mp="1z372alxi684o">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-calm hover:bg-amber-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-amber-200 md:px-7" data-id="element-48" data-mp="1z3oyjik60mcl">
                  <span className="font-display text-lg font-extrabold tracking-tight text-night" data-id="element-49" data-mp="ufzh9w2sxl15">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-amber-700 transition-transform duration-200 ease-calm ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-50" data-mp="kiuym68607p3" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-51" data-mp="3sz6i00jnyvn1">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-52" data-mp="1sd6a2r8ve49">
                    <p className="px-5 pb-6 text-lg leading-relaxed text-gray-600 md:px-7" data-id="element-53" data-mp="1uhmj19dvkdhw">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}